var PDFViewer = PDFViewer || {};

PDFViewer.init = function () {
// Loaded via <script> tag, create shortcut to access PDF.js exports.
    var pdfjsLib = window['pdfjs-dist/build/pdf'];

    // The workerSrc property shall be specified.
    pdfjsLib.GlobalWorkerOptions.workerSrc = '/js/vendor/pdf.worker.js';

    PDFViewer.listenForClick();

    window.addEventListener('scroll', () => {
        document.documentElement.style.setProperty('--scroll-y', `${window.scrollY}px`);
    });
};

PDFViewer.loadPdf = function(url) {
    const modal = document.getElementById('elecnor-viewer-modal');
    modal.classList.add("open");
    document.body.classList.add("no-scroll");

    const canvas = document.getElementById('pdf-canvas');
    if (canvas) {
        PDFViewer.loadPdfInCanvas(url);
    }

    const embed = document.getElementById('pdf-embed');
    if (embed) {
        PDFViewer.loadPdfInEmbed(url);
    }
};

PDFViewer.loadPdfInEmbed = function (url) {
    const embed = document.getElementById('pdf-embed');
    embed.setAttribute('src', url);
    
    // Forzar un reflow/repaint del embed
    setTimeout(() => {
        embed.style.display = 'none';
        embed.offsetHeight; // force reflow
        embed.style.display = 'block';
    }, 100);
};

PDFViewer.loadPdfInCanvas = function (url) {
    // Asynchronous download of PDF
    var loadingTask = pdfjsLib.getDocument(url);
    loadingTask.promise.then(function(pdf) {
        // Fetch the first page
        var pageNumber = 1;
        pdf.getPage(pageNumber).then(function(page) {
            console.log('Page loaded');

            var scale = 1.5;
            var viewport = page.getViewport({scale: scale});

            // Prepare canvas using PDF page dimensions
            var canvas = document.getElementById('pdf-canvas');
            var context = canvas.getContext('2d');
            canvas.height = viewport.height;
            canvas.width = viewport.width;

            // Render PDF page into canvas context
            var renderContext = {
                canvasContext: context,
                viewport: viewport
            };
            var renderTask = page.render(renderContext);
            renderTask.promise.then(function () {
                console.log('Page rendered');
            });
        });
    }, function (reason) {
        // PDF loading error
        console.error(reason);
    });
}

PDFViewer.closeModal = function () {
    const modalWrapper = document.getElementById('elecnor-viewer-modal');
    modalWrapper.classList.remove("open");
    document.body.classList.remove("no-scroll");
    const embed = document.getElementById('pdf-embed');
    //embed.setAttribute('src', '');
}

PDFViewer.listenForClick = function () {
    document.addEventListener('click', function (event) {
        const button = event.target.closest('.js-view-pdf');
        if (!button) return;
        const url = button.getAttribute('href') || '';
        if (url.endsWith('.pdf')) {
            event.preventDefault();
            PDFViewer.loadPdf(url);
        }
    });

    const modalWrapper = document.getElementById('elecnor-viewer-modal');
    if (modalWrapper) {
        modalWrapper.addEventListener('click', () => PDFViewer.closeModal());
    }
    const embed = document.getElementById('pdf-embed');
    if (embed) {
        embed.addEventListener('click', (e) => e.stopPropagation());
    }
};

PDFViewer.openInChromeMobileViewer = function () {
    const $buttons = $('.js-view-pdf');

    $buttons.each(function() {
        let itemHref = $(this).attr('href');
        itemHref = 'https://docs.google.com/viewerng/viewer?url=' + itemHref;
        $(this).attr('href', itemHref);
    })
};

$(document).ready(function (e) {
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    const isChrome = /Chrome/i.test(navigator.userAgent);
    if (!isMobile) {
        const canvas = document.getElementById('pdf-canvas');
        const embed = document.getElementById('pdf-embed');
        if (canvas || embed) {
            PDFViewer.init();
            if (canvas) {
                var url = canvas.getAttribute('data-url');
                if (url) {
                    PDFViewer.loadPdf(url);
                }
            }
        }
    } else {
        if(isChrome) {
            PDFViewer.openInChromeMobileViewer();
        }
    } 
});